import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFile,
  faFiles,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { Badge } from "../ui/badge";

export const FileCountBadge = ({ count }: { count: number }) => {
  return (
    <Badge
      variant="outline"
      className="flex flex-row items-center gap-2 text-sm"
    >
      {count === 0 && "No files"}
      {count === 1 && (
        <>
          <FontAwesomeIcon icon={faFile} /> 1 File
        </>
      )}
      {count > 1 && (
        <>
          <FontAwesomeIcon icon={faFiles} /> {count} Files
        </>
      )}
    </Badge>
  );
};
